import { useMemo } from 'react';

import { loaders } from 'entities';

import { useAuth } from 'providers/Auth';

import { sortByName } from 'utils/array';
import { WithChildrenProps } from 'types/react';

import { teamCtx } from './team.context';

export function TeamProvider({ children }: WithChildrenProps) {
  const { loginAction, user } = useAuth();

  const { errorOrLoading: loadingUsers, data: teamUsers } = loaders.users.teamUsers.use({
    blockLoad: !!loginAction,

    defaultValue: [],

    parser: (users) => sortByName(users.filter(({ disabled }) => !disabled)),

    params: {
      team: user.data.team?.id,
    },
  });

  const data = useMemo(
    () => ({
      loadingUsers,
      teamUsers,
    }),
    [teamUsers, loadingUsers],
  );

  return <teamCtx.Provider value={data}>{children}</teamCtx.Provider>;
}
